// extracted by mini-css-extract-plugin
export default {"body":"introSeo_body__hu8rD","tag":"introSeo_tag__-LTya","header":"introSeo_header__YsRtF","text":"introSeo_text__l1KqR","btn":"introSeo_btn__cb0nQ"};